import { render, staticRenderFns } from "./ViewParams.vue?vue&type=template&id=f548fd82&scoped=true"
import script from "./ViewParams.vue?vue&type=script&lang=js"
export * from "./ViewParams.vue?vue&type=script&lang=js"
import style0 from "./ViewParams.vue?vue&type=style&index=0&id=f548fd82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f548fd82",
  null
  
)

export default component.exports